<template>
    <v-card>
        <v-card-text>
            <v-row>
                <v-col>
                    <contact-form ref="contactForm" :init-jur-id="parseInt(jurId)" :init-contact-id="parseInt(contactId)" @created="onContactCreated" @loaded="onLoadedContact"/>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider class="mx-4"></v-divider>
        <v-card-title>Контактная информация</v-card-title>
        <v-card-text>
            <v-row v-if="contactId">
                <v-col cols="6">
                    <contact-info-form :init-contact-id="parseInt(contactId)" @added="onAddContactInfo"/>
                </v-col>
                <v-col cols="6">
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left">
                                    Почта
                                </th>
                                <th class="text-left">
                                    Телефон
                                </th>
                                <th class="text-left">
                                    Юридическую информацию как основную
                                </th>
                                <th class="text-left">
                                    Контакт как основной
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="contactInfo in contactInfos"
                                :key="contactInfo.id"
                            >
                                <td>{{ contactInfo.email }}</td>
                                <td>{{ contactInfo.phone }}</td>
                                <td>{{ contactInfo.is_jur_primary ? "ДА" : "НЕТ"}}</td>
                                <td>{{ contactInfo.is_contact_primary  ? "ДА" : "НЕТ"}}</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import ContactForm from "../../components/contragents/ContactForm.vue";
import ContactInfoForm from "../../components/contragents/ContactInfoForm.vue";

export default {
    name: "ContactCreatePage",
    components: {ContactInfoForm, ContactForm},
    data(){
        return {
            contactInfos: []
        }
    },
    methods: {
        onContactCreated(contact){
            if(contact.jur_id){
                this.$router.push({name: 'JurContactEditPage', params: { jurId: contact.jur_id,  contactId: contact.id}})
            }else{
                this.$router.push({name: 'ContactEditPage', params: {contactId: contact.id}})
            }
        },
        onLoadedContact(contact){
            this.contactInfos.splice(0, this.contactInfos.length, ...contact.contact_infos)
        },
        onAddContactInfo(){
            this.$refs.contactForm.load(this.contactId)
        }
    },
    computed: {
        jurId(){
            return this.$route.params.jurId;
        },
        contactId(){
            return this.$route.params.contactId;
        }
    }
}
</script>

<style scoped>

</style>